class productDetails extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelector('[data-tabs]');
    this.triggers = Array.from(this.querySelectorAll('[data-tab-trigger]'));

    this.productDescription = this.querySelector('[data-product-description]');
    this.readMoreButton = this.querySelector('[data-read-more-details]');

    this.specifications = Array.from(this.querySelectorAll('[data-specification]'));
    this.recentlyViewedProducts = this.querySelector('[data-recently-viewed-products]');

    this.popup = this.querySelector('[data-specifications-popup]');
    this.popupShadow = this.querySelector('[data-specifications-popup-shadow]');
    this.popupWrapper = this.querySelector('[data-specifications-popup-wrapper]');
    this.popupClose = this.querySelector('[data-specifications-popup-close]');

    this.popupClose?.addEventListener('click', () => this.close());
    this.popupShadow?.addEventListener('click', () => this.close());
    this.readMoreButton?.addEventListener('click', () => this.productDescription.classList.toggle('product-details__description--active'));

    if (this.tabs && this.tabs.classList.contains('product-details__tabs--sticky')) {
      setTimeout(() => {
        this.tabs.style.top = `${document.querySelector('.header__top').clientHeight + document.querySelector('[data-sticky-add-to-cart]').clientHeight + 16}px`;
      }, 100);
    }

    this.descriptionPopup();
    this.scrollToTab();
    this.recentlyViewed();
  }

  updateSpecificationPopup(specificationDescription) {
    if (specificationDescription !== '' && specificationDescription !== ' ') {
      this.popup.classList.add('active', 'animate');
      this.popupWrapper.textContent = specificationDescription;
    }
  }

  // close the popup
  close() {
    this.popup.classList.remove('active', 'animate');
  }

  descriptionPopup() {
    const that = this;

    this.specifications.map((specification) => {

      specification.querySelector('[data-specification-trigger]')?.addEventListener('click', function() {
        that.updateSpecificationPopup(specification.dataset.specificationDescription);
      });

    })
  }

  scrollToTab() {
    this.triggers.map((trigger) => {
      trigger.addEventListener('click', () => {
        const triggerTitle = trigger.dataset.tabTrigger;
        const targetY = this.querySelector(`[data-tab-target="${triggerTitle}"]`)?.offsetTop;
        const headerHeight = document.querySelector('.header__top').clientHeight;
        const triggerHeight = this.querySelector(`[data-tab-trigger="${triggerTitle}"]`).clientHeight;
        const stickyAddToCartHeight = document.querySelector('[data-sticky-add-to-cart]').clientHeight;
        const scrollLevel = this.tabs.classList.contains('product-details__tabs--sticky') ? targetY - headerHeight - triggerHeight - stickyAddToCartHeight : targetY - headerHeight;

        window.scrollTo({
          top: scrollLevel,
          behavior: 'smooth'
        });
      })
    })
  }

  recentlyViewed() {
    const recentViews = JSON.parse(localStorage.getItem('lsRecentViews'));

    if (this.recentlyViewedProducts) {
      if (!recentViews || recentViews.length < 2) {
        this.recentlyViewedProducts.style.display = 'none';
      }
    }
  }

}

if(!customElements.get('product-details')) {
  customElements.define('product-details', productDetails);
}
